import type { User } from '../types';

export const mockUsers: User[] = [
  {
    id: 'user-001',
    username: 'demo@blackbook.com',
    email: 'demo@blackbook.com',
    firstName: 'Demo',
    lastName: 'User',
    company: 'Black Book Demo',
    subscriptions: ['usedCar', 'newCar', 'truck', 'powerSports', 'rv', 'cpi', 'residuals'],
    preferences: {
      defaultProduct: 'usedCar',
      region: 'National',
      theme: 'light'
    }
  },
  {
    id: 'user-002', 
    username: 'dealer@example.com',
    email: 'dealer@example.com',
    firstName: 'John',
    lastName: 'Dealer',
    company: 'ABC Auto Sales',
    subscriptions: ['usedCar', 'newCar'],
    preferences: {
      defaultProduct: 'usedCar',
      region: 'Southeast',
      theme: 'light'
    }
  }
];

export const currentUser = mockUsers[0];